export default () => ({
  layoutType: 'vertical',
  layoutWidth: 'fluid',
  leftSidebarType: 'dark',
  topbar: 'dark',
  toggleMenu: true,
  mapStyle: {id:'light',value: 'mapbox://styles/mapbox/light-v10', text: 'Light', color: 'light'},
  isMap: false,
});
